import React, { Component } from "react";
import { putApi } from "../../utils/DatabaseHelper";
import { toast } from "react-toastify";
import logger from "../../logging/logger";

class MfaSettings extends Component {
    constructor(props) {
        super(props);
        this.state = { enabled: false };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.settings !== this.props.settings && typeof this.props.settings !== 'undefined') {
            this.setState({ enabled: this.props.settings.enabled === true });
        }
    }

    async toggle() {
        const next = !this.state.enabled;
        this.setState({ enabled: next });
        try {
            await putApi("einstellungen", 'MfaSettings', {
                widget_config: JSON.stringify({ enabled: next }),
                firmenId: this.props.firmenId === undefined ? null : this.props.firmenId
            });
            const scopeLabel = this.props.firmaLabel || "Global";
            toast.success(next
                ? `Zwei-Faktor-Authentifizierung f&uuml;r ${scopeLabel} aktiviert.`
                : `Zwei-Faktor-Authentifizierung f&uuml;r ${scopeLabel} deaktiviert.`
            );
        } catch (err) {
            logger.error('MfaSettings speichern fehlgeschlagen', err);
            toast.error("Speichern fehlgeschlagen.");
            this.setState({ enabled: !next });
        }
    }

    render() {
        const { enabled } = this.state;
        const scopeLabel = this.props.firmaLabel || "Global";
        return (
            <div className="mfa-settings">
                <div className="heading row mb-3">
                    <h5 className="col">Zwei-Faktor-Authentifizierung f&uuml;r {scopeLabel}</h5>
                </div>
                <div className="card">
                    <div className="card-body">
                        <p className="mfa-description">
                            Wenn aktiviert, wird nach der Passwort-Eingabe ein 6-stelliger Code
                            per E-Mail angefordert, bevor die Anmeldung abgeschlossen ist.
                        </p>
                        <div className="mfa-toggle-row">
                            <span className="mfa-toggle-label">MFA aktiv</span>
                            <label className="switch" htmlFor="mfaEnabled">
                                <input
                                    type="checkbox"
                                    id="mfaEnabled"
                                    checked={enabled}
                                    onChange={() => this.toggle()}
                                />
                                <span className="slider round"></span>
                            </label>
                            <span className={`mfa-status ${enabled ? 'active' : ''}`}>
                                {enabled ? 'Aktiviert' : 'Deaktiviert'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MfaSettings;
